import React, { useCallback, useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import axios from "axios";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { languageHelper } from "../../../config/helperFunctions";
import Dropdown from "../../../components/AdminDropdown/Dropdown";
import { MdDeliveryDining } from "react-icons/md";

function CheckBox({ row, user, status }) {
  const initialChecked = row.getValue() === "active";
  const [isChecked, setIsChecked] = useState(initialChecked);
  const [isLoading, setIsLoading] = useState(false);

  const handleUpdate = (e) => {
    const newChecked = e.target.checked;
    setIsLoading(true);

    axios
      .put(
        `${apiKey}/api/rms/admin/foodMenus/${row.row.original.id}`,
        {
          [status]: newChecked ? "active" : "inactive",
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        },
      )
      .then((res) => {
        toast.success(res.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setIsChecked(newChecked);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="relative">
      <input
        type="checkbox"
        onChange={handleUpdate}
        checked={isChecked}
        className="theme-checkbox"
      />
      {isLoading && (
        <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50 z-10 rounded-full">
          <img
            className="w-4 mx-auto"
            src="/assets/gif/button_loader.gif"
            alt=""
          />
        </span>
      )}
    </div>
  );
}

function Deals() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [pageLoading, setPageLoading] = useState(false);
  const [error, setError] = useState("");

  const columns = [
    {
      header: languageHelper("SN") || "SN",
      // accessorKey: "id",
      cell: (row) => row.row.index + 1,
    },
    {
      header: languageHelper("Code") || "Code",
      accessorKey: "code",
    },
    {
      header: languageHelper("Name") || "Name",
      accessorKey: "name",
    },
    {
      header: languageHelper("Name Arabic") || "Name Arabic",
      accessorKey: "name_arabic",
    },
    {
      header: languageHelper("Category") || "Category",
      accessorKey: "category_name",
      cell: (cat) => cat.row.original.category?.category_name,
    },
    {
      header: languageHelper("Sale Price") || "Sale Price",
      accessorKey: "sale_price",
    },
    {
      header: languageHelper("Total Items") || "Total Items",
      cell: (item) => {
        const total = JSON.parse(item.row.original.deal_details)?.length;
        return total;
      },
    },
    {
      header: languageHelper("Added By") || "Added By",
      cell: (user) => user.row.original.user?.name,
    },
    {
      header: languageHelper("Status") || "Status",
      accessorKey: "status",
      cell: (row) => (
        <CheckBox
          key={`web_status_${row.row.original.id}`}
          row={row}
          status={"status"}
          user={user}
        />
      ),
    },
    {
      header: languageHelper("Actions") || "Actions",
      cell: (row) => (
        <Dropdown
          id={row.row.original.id}
          options={dropdownOptions}
        />
      ),
    },
  ];

  const [data, setData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState();
  const [deleteId, setDeleteId] = useState(null);

  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  const dropdownOptions = [
    {
      name: languageHelper("Edit"),
      icon: <FaEdit />,
      func: (id) => {
        navigate(`addDeals/${id}`);
      },
    },
    {
      name: languageHelper("Assign Delivery Company"),
      icon: <MdDeliveryDining />,
      func: (id) => {
        navigate(`assignDeliveryCompany/${id}`);
      },
    },
    {
      name: languageHelper("Delete"),
      icon: <FaTrashAlt />,
      func: (id) => {
        // Handle delete action
        setDeleteId(id);
      },
    },
  ];

  const buttonData = [
    {
      buttonText: languageHelper("Add Deal"),
      path: "addDeals",
    },
  ];

  const handleDelete = (id) => {
    axios
      .delete(`${apiKey}/api/rms/admin/foodMenus/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data.data, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        fetchItems();
        setDeleteId(null);
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const handleCategory = (e) => {
    setSelectedCategory(e.value);
  };

  useEffect(() => {
    const fetchCategories = (csrfToken) => {
      axios
        .get(`${apiKey}/api/rms/admin/categories`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          const mappedCategories = res.data.map((cat) => ({
            value: cat.id,
            label: cat.category_name,
          }));
          setCategories(mappedCategories);
        })
        .catch((err) => {
          setError(err.response.data.message);
        });
    };

    handleCSRF(fetchCategories);
  }, [user?.token]);

  const fetchItems = useCallback(async () => {
    try {
      try {
        const res = await axios.get(`${apiKey}/api/rms/admin/foodMenus`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
          params: {
            category: selectedCategory,
            outletId: user?.user.outlet_id,
            isDeal: "yes",
          },
        });
        setData(res.data.foodMenus);
      } catch (err) {
        setError(err.response.data.message);
      }
    } finally {
      return setPageLoading(false);
    }
  }, [selectedCategory, user?.token, user?.user.outlet_id]);

  useEffect(() => {
    setPageLoading(true);

    handleCSRF(fetchItems);
  }, [fetchItems, selectedCategory, user.token]);

  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        error={error}
        heading={"Deals"}
        buttonData={buttonData}
        categories={categories}
        handleSelect={handleCategory}
      />
      {pageLoading && (
        <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
          <img src="/assets/gif/dash2.gif" alt="" />
        </div>
      )}{" "}
      {deleteId && (
        <div
          className="w-full h-screen overflow-y-auto grid place-items-center fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md p-4 z-10"
          onClick={() => setDeleteId(null)}
        >
          <div
            className="p-4 rounded-lg bg-white max-w-md w-full space-y-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="space-y-4">
              <h1 className="text-d-bg-text font-semibold text-xl text-center">
                {languageHelper("Alert!") || "Alert!"}
              </h1>
              <p className="text-center text-gray-700">
                {languageHelper("Are you sure?")}
              </p>
            </div>
            <div className="flex justify-center gap-4">
              <button
                className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
                onClick={() => setDeleteId(null)}
              >
                {languageHelper("No") || "No"}
              </button>
              <button
                onClick={() => handleDelete(deleteId)}
                className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
              >
                {languageHelper("Yes") || "Yes"}
              </button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}

export default Deals;
